import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router
  ) { }

  private isAuthenticated = false; // Mock authentication status

  // Mock login method
  login(email: string, password: string): boolean {
    const validCredentials = email === 'test@mail.com' && password === 'test@123';
    if (validCredentials) {
      this.isAuthenticated = true; // Set user as authenticated
    }
    return validCredentials;
  }

  logout(): void {
    this.isAuthenticated = false; // Reset authentication status
    this.router.navigate(['/login']); // Redirect to login
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated; // Check authentication status
  }
}
